import merge from 'deepmerge';
import { type StandardData } from '../../index';

export function dataFormatter(data: unknown[]): { value: unknown[]; [propName: string]: any }[] {
  if (!data.length) {
    return [];
  }
  const dataClone = merge([], data);
  const sample = dataClone[0];
  // single value
  if (typeof sample === 'number' || typeof sample === 'string') {
    return dataClone.map((d, i) => {
      return {
        value: [i, d]
      };
    });
  }
  // value array
  if (Array.isArray(sample)) {
    return dataClone.map(d => {
      return {
        value: d as unknown[]
      };
    });
  }
  // value object
  return dataClone as { value: unknown[] }[];
}

export function getExtremeValue(data: StandardData, index = 0, key = 'value'): [number, number] {
  const target = data.map(d => d[key][index] as number);
  return [Math.min(...target), Math.max(...target)];
}
